import qs from "qs";
import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { LocalStorageKeys, PaymentStatus, ROUTES } from "@is/constants";
import { useCheckoutOrderConfirm } from "@is/hooks/checkout";
import { LocalStorageService } from "@is/services";

const useManageForwardBasket = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { tenantId, sessionId, languageCode, checkoutConfigurationId } =
    qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

  const [{ data, error }, checkoutOrderConfirm] = useCheckoutOrderConfirm();

  useEffect(() => {
    if (
      typeof tenantId === "string" &&
      typeof sessionId === "string" &&
      typeof languageCode === "string" &&
      (typeof checkoutConfigurationId === "string" ||
        typeof checkoutConfigurationId === "undefined")
    ) {
      LocalStorageService.setItem(LocalStorageKeys.LanguageCode, languageCode);

      checkoutOrderConfirm({
        tenantId,
        sessionId,
        ...(!!checkoutConfigurationId && { checkoutConfigurationId }),
      });
    }
  }, [
    checkoutConfigurationId,
    checkoutOrderConfirm,
    languageCode,
    sessionId,
    tenantId,
  ]);

  const redirectUri = useMemo(
    () => data?.checkoutAttempts?.slice(-1)?.[0]?.result?.redirectUri,
    [data]
  );

  useEffect(() => {
    if (data && !!redirectUri?.length) {
      window.location.href = redirectUri;
    } else if (data) {
      navigate(ROUTES.SuccessView);
      return;
    } else if (error && error.body.status === PaymentStatus.LinkExpired) {
      navigate(ROUTES.ErrorExpiredView);
      return;
    } else if (error) {
      const errorMessage =
        error?.body?.checkoutAttempts?.slice(-1)?.[0]?.result?.message;

      if (errorMessage) {
        LocalStorageService.setItem(
          LocalStorageKeys.CheckoutErrorMessage,
          errorMessage
        );
      }

      navigate(ROUTES.ErrorView);
      return;
    }
  }, [data, error, navigate, redirectUri]);
};

export default useManageForwardBasket;
